export class LoadingSpinner {
    private static spinnerElement?: HTMLDivElement;
    private static disabled: boolean;

    public static show = () => {
        if (this.disabled) return;
        this.createSpinnerElement();
    }

    public static hide = () => {
        this.destroySpinnerElment();
    }

    public static disable = () => {
        this.disabled = true;
    }

    public static registerNavigationEvents = (selector: string) => {
        const nodes = document.querySelectorAll(selector);
        for (const node of nodes) {
            const event = node.tagName === "FORM" ? 'submit' : 'click';
            node.addEventListener(event, () => this.show());
        }
        const downloads = document.querySelectorAll('form[action*="download"]');
        for (const form of downloads) {
            form.addEventListener('submit', () => this.disable());
        }
    }

    private static createSpinnerElement = () => {
        if (document.body.classList.contains('is-loading')) return;
        if (this.spinnerElement) return;

        this.spinnerElement = document.createElement('div');
        this.spinnerElement.setAttribute('aria-live', 'polite');
        this.spinnerElement.setAttribute('aria-label', 'Page loading, please wait.');

        document.body.classList.add('is-loading');
        document.body.append(this.spinnerElement);

        setTimeout(() => document.body.classList.add('visible'), 10)
    }

    private static destroySpinnerElment = () => {
        if (!this.spinnerElement) return;
        document.body.classList.remove('visible');
        document.body.classList.remove('is-loading');
        setTimeout(() => this.spinnerElement?.remove(), 750);
    }
}

